import { Controller } from '@hotwired/stimulus';

// Connects to data-controller='integrations--checkbox'
export default class extends Controller {
  static targets = ['checkbox'];
  static outlets = ['integrations--checkbox-sync'];

  connect() {
    this.#reInitializeCheckboxes();
  }

  toggle(event) {
    this.integrationsCheckboxSyncOutlet.toggleIdenticalCheckboxes(event.target);
  }

  clearCheckboxes() {
    this.checkboxTargets.filter((checkbox) => checkbox.checked).map(checkbox => {
      checkbox.checked = false;
    });

    this.#reInitializeCheckboxes();
  }

  #reInitializeCheckboxes() {
    if (this.hasIntegrationsCheckboxSyncOutlet) {
      this.integrationsCheckboxSyncOutlet.initializeCheckboxes();
    }
  }
}
